export const DEFAULT_PAGE_HEAD = 'Refer a friend | Mad Paws';
export const TITLE = 'Spread the love & earn';
export const DESCRIPTION = `Invite a friend to Mad Paws and you\'ll both receive $25 credit for your next booking.`;
export const HINT = 'Copy your invite link';

export const HOW_IT_WORKS = [
  {
    title: 'Share your unique link',
    description: 'With a friend of family member.',
  },
  {
    title: 'They get $25 credit',
    description: 'When they sign up with your unique link.',
  },
  {
    title: 'You get $25 credit',
    description: 'When they finish their first Mad Paws booking.',
  },
];

export const FAQS = [
  {
    question: 'Why should I refer a friend to Mad Paws?',
    answer: [
      'Upon referring a friend to Mad Paws, they receive $25 credit so you are helping them out, and you receive $25 toward your next booking after they complete their first booking. A true win-win!',
    ],
  },
  {
    question: 'Can I refer friend to be a pet sitter on Mad Paws?',
    answer: [
      'Although you only receive credit for referring someone that completes a booking as a pet owner, you are expanding the network of trusted Mad Paws sitters in your community! Often Mad Paws pet sitters are also pet owners, so if the referred sitter ever completes a booking as a pet owner you will receive credit.',
    ],
  },
  {
    question: 'I referred a friend, when will I receive my $25 Mad Paws Credit?',
    answer: [
      'Your $25 Mad paws credit will automatically be applied to your account once the pet owner you referred completes their first booking.',
    ],
  },
  {
    question: 'Where in my account can I find my Mad Paws Credit?',
    answer: [
      'When your $25 Mad Paws credit is applied to your account, the credit will appear in your account favourites. To find this page simply click on your profile located on the top right corner of the Mad Paws website, and navigate to “Favourites”. Your Mad Paws credit will appear in your “Mad Paws Credits” widget.',
    ],
  },
  {
    question: 'Is there a limit on how many people I can refer?',
    answer: ['No, there is not a limit to how many people you can refer.'],
  },
  {
    question: 'Does the Mad Paws Referral Credit ever expire?',
    answer: ['No, the Mad Paws credit has no expiration date.'],
  },
];
